import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentModel, DocumentTypesModel, XmlFile } from './documents.types';
import { LoaderEnabled } from '../../services/loader.service';

@Injectable({
  providedIn: 'root',
})

export class DocumentsApiService {
  constructor(private httpClient: HttpClient) {}

  @LoaderEnabled()
  fetchDocuments(): Observable<DocumentModel[]> {
    return this.httpClient.get<DocumentModel[]>('/api/organisation/documents');
  }

  @LoaderEnabled()
  fetchDocumentTypes(): Observable<DocumentTypesModel> {
    return this.httpClient.get<DocumentTypesModel>('/api/documents/types');
  }

  @LoaderEnabled()
  downloadXmlDocument(url: string): Observable<XmlFile> {
    return this.httpClient.get(url, {
      responseType: 'text',
    });
  }
}
